export const isEmail = (value: string): boolean => {
	// Simple email validation previously used in Orders.UI.
	// Regex decoded: Has only one @, at least one character before and after the @, and has at least 2 chars after the dot
	const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;
	
	if (!value || value.trim().length === 0) {
		return false;
	}

	return emailRegex.test(value);
};
